export type CheckpointReason = 'idle' | 'pagehide' | 'exit'
type Checkpoint = (reason: CheckpointReason) => Promise<boolean>
const checkpoints = new Map<string, Checkpoint>()

export function registerCheckpoint(key: string, checkpoint: Checkpoint) {
  checkpoints.set(key, checkpoint)
  return () => {
    if (checkpoints.get(key) === checkpoint) checkpoints.delete(key)
  }
}

export async function flushCheckpoints(reason: CheckpointReason): Promise<boolean> {
  const results = await Promise.allSettled([...checkpoints.values()].map(checkpoint => checkpoint(reason)))
  return results.every(result => result.status === 'fulfilled' && result.value)
}
